import { render, staticRenderFns } from "./customized.vue?vue&type=template&id=1da33306"
import script from "./customized.vue?vue&type=script&lang=js"
export * from "./customized.vue?vue&type=script&lang=js"
import style0 from "./customized.vue?vue&type=style&index=0&id=1da33306&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports